module.exports = "/_next/static/images/bangalore-7f73122218fbbaee757528e15fb27497.png";